import React from 'react'
import roomBackgroundImage from '../bg.jpg'
import roomBackgroundImageLow from '../bg_small.jpg'

const Layout = ({ children, show }) => {
  return (
    <div
      className="bgContainer"
      style={{
        // opacity: show ? 1 : 0,
        position: 'relative',
        height: '100vh',
        width: '100vw',
        zIndex: 2,
        backgroundImage: `url(${roomBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        color: '#fff',
        padding: '11.11vh 9.375vw',
        overflow: 'hidden',
      }}
    >
      <div
        className="thumbnail"
        style={{
          backgroundImage: `url(${roomBackgroundImageLow})`,
        }}
      />
      <div
        style={{
          height: '100%',
          width: '100%',
          position: 'relative',
          zIndex: 11,
          transition: 'all 0.4s 0.6s',
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default Layout
